import { clone, map, compact } from 'lodash';
import axios from '../axios';

export default {
  validateKycIntroduction() {
    return axios.post('/kyc/validate_introduction');
  },
  update(data) {
    const kyc = clone(data);
    if (data.childrenAges.length) {
      kyc.childrenAges = compact(map(data.childrenAges, 'value'));
    }
    if (!data.knowledgeAnswers.length) {
      delete kyc.knowledgeAnswers;
    }
    if (!data.goalAnswers.length) {
      delete kyc.goalAnswers;
    }
    return axios.patch('/kyc', { kyc });
  },
  fetchOngoing() {
    return axios.get('/kyc/ongoing');
  },
  fetchValidated() {
    return axios.get('/kyc/validated');
  },
  fetchKnowledgeQuestions() {
    return axios.get('/kyc/knowledge_questions');
  },
  fetchGoalQuestions() {
    return axios.get('/kyc/goal_questions');
  },
  uploadDocument(file, url) {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  uploadIdentityDocument(file) {
    return this.uploadDocument(file, '/kyc/identity_document');
  },
  uploadExtraIdentityDocument(file) {
    return this.uploadDocument(file, '/kyc/extra_identity_document');
  },
  uploadProofOfAddress(file) {
    return this.uploadDocument(file, '/kyc/proof_of_address_document');
  },
  submit() {
    return axios.post('/kyc/submit');
  },
  sign() {
    return axios.post('/kyc/sign');
  },
};
